import baseService from "./base.service";

export const getSupportedLanguages = async () => {
  return baseService
    .get(`/record/supported_language`)
    .then((response) => response)
    .catch((error) => {
      console.log("api error:", error);
    });
};

export const getRecordConvertTypes = async () => {
  return baseService
    .get(`/record/convert_type`)
    .then((response) => response)
    .catch((error) => {
      console.log("api error:", error);
    });
};

export const getFileFormats = async () => {
    return baseService
      .get(`/record/file_format`)
      .then((response) => response)
      .catch((error) => {
        console.log("api error:", error);
      });
  };